export default "__VITE_ASSET__DRdJEKTA__"